export const sizes = {
  widePlus: 2048,
  wide: 1536,
  layoutPlus: 1280,
  layout: 1008,
  container: '100%',
  // copyUltra: 980,
  // copyPlus: 768,
  copy: 774
  // narrowPlus: 600,
  // narrow: 526
}
